import Feature from "src/js/stores/user/Feature";
import {
  UKTopographyLayerType,
  TopographySlopeLayerType,
  TopographyAspectLayerType,
} from "../layer_types/TopographyLayerType";
import { Layer, LayerGroup } from "../types";

export const TOPOGRAPHY_LAYER_UK: Layer = {
  id: "TopographyLayer",
  layerType: UKTopographyLayerType,
  requiredFeatureAccess: [Feature.topographyUK],
  group: LayerGroup.ENVIRONMENTAL,
  icon: "lt-layer-topography",
  description: "Slope and aspect",
  title: "Topography",
  hideByDefault: true,
  toggleable: true,
  collapsed: true,
  zoomConfig: {
    minVisualisationZoom: 6,
  },
};

export const TOPOGRAPHY_INSIGHT_SLOPE_SUMMARY: Layer = {
  ...TOPOGRAPHY_LAYER_UK,
  title: "Slope",
  id: "TopographySlopeSummary",
  layerType: TopographySlopeLayerType,
};

export const TOPOGRAPHY_INSIGHT_ASPECT_SUMMARY: Layer = {
  ...TOPOGRAPHY_LAYER_UK,
  title: "Aspect",
  id: "TopographyAspectSummary",
  layerType: TopographyAspectLayerType,
};
